export default (question, originalValue, graphRange) =>
  ((originalValue - question.minValue) * (graphRange.max - graphRange.min)) /
    (question.maxValue - question.minValue) +
  graphRange.min;
